module.exports = __webpack_public_path__ + "img/work_title.c44fda75.png";